var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.625,
    height: 30.624,
    viewBox: "0 0 30.625 30.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload_2_",
    "data-name": "upload (2)",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54487",
    "data-name": "Path 54487",
    d: "M30.233,13a1.392,1.392,0,0,0-1.392,1.392v5.865a3.884,3.884,0,0,1-3.88,3.88H7.664a3.884,3.884,0,0,1-3.88-3.88V14.392a1.392,1.392,0,0,0-2.784,0v5.865A6.671,6.671,0,0,0,7.664,26.92h17.3a6.671,6.671,0,0,0,6.664-6.664V14.392A1.392,1.392,0,0,0,30.233,13Z",
    transform: "translate(0 4.704)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54488",
    "data-name": "Path 54488",
    d: "M7.376,11.728l5.976-5.976v17.52a1.392,1.392,0,0,0,2.784,0V5.752l5.976,5.976A1.392,1.392,0,1,0,24.081,9.76L15.728,1.408a1.392,1.392,0,0,0-1.968,0L5.408,9.76a1.392,1.392,0,1,0,1.968,1.968Z",
    transform: "translate(1.568 0)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUpload);
export default __webpack_public_path__ + "static/media/default-upload.e59a697aaca11352ae401aec62425f02.svg";
export { ForwardRef as ReactComponent };